import { NgModule } from '@angular/core';
import { MyImunifyPromoDialogService } from './my-imunify-promo-dialog.service';
import { I360ModalModule } from 'app/utils/modals/modal.module';

@NgModule({
    imports: [I360ModalModule],
    providers: [MyImunifyPromoDialogService],
})
export class MyImunifyPromoDialogModule {}
